import { Icon, Text } from '@fairfashion/design-system'

import * as Styles from './avatar-menu-item.styles'
import { AvatarMenuItemProps } from './avatar-menu-item.types'

export const AvatarMenuItem = ({
  onClick,
  icon,
  label,
}: AvatarMenuItemProps) => {
  return (
    <Styles.AvatarMenuItemWrapper
      direction="row"
      width="100%"
      padding={2}
      gap={2}
      alignItems="center"
      onClick={onClick}
    >
      <Icon name={icon} color="grey_3" size={24} />
      <Text variant="p" size="small" color="grey_3">
        {label}
      </Text>
    </Styles.AvatarMenuItemWrapper>
  )
}
